export default "__VITE_ASSET__323fefdb__"